import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/Footer.module.css';

const SOCIALS = [
  { label: '𝕏', href: 'https://twitter.com/inviteEngine3', aria: 'Twitter' },
  { label: 'in', href: 'https://linkedin.com/company/inviteengine', aria: 'LinkedIn' },
  { label: 'YT', href: 'https://www.youtube.com/@InviteEngine3', aria: 'YouTube' },
];

const COLS = [
  {
    title: 'Services',
    links: [
      { label: 'Inbox to Invite',        to: '/services' },
      { label: 'Dials to Discovery',     to: '/services' },
      { label: 'Full Spectrum Outreach', to: '/services' },
      { label: 'Reach at Scale',         to: '/services' },
      { label: 'Outcome-Driven Outreach',to: '/services' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'Home',      to: '/' },
      { label: 'About Us',  to: '/about' },
      { label: 'Services',  to: '/services' },
      { label: 'Contact',   to: '/contact' },
    ],
  },
  {
    title: 'Contact',
    links: [
      { label: 'Book a Free Call',     to: '/contact' },
      { label: 'Request a Strategy',   to: '/contact' },
      { label: 'connect@inviteengine.com', href: 'mailto:connect@inviteengine.com' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.top}>
          <div>
            <Link to="/" className={styles.brand}>Invite<span>Engine</span></Link>
            <p className={styles.tagline}>
              We fill your calendar with qualified conversations. You drive the growth.
            </p>
            
            <div className={styles.socials}>
              {SOCIALS.map((s) => (
                <a 
                  key={s.label} 
                  href={s.href} 
                  className={styles.socialBtn} 
                  aria-label={s.aria}
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  {s.label}
                </a>
              ))}
            </div>

          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <p className={styles.colTitle}>{col.title}</p>
              <ul className={styles.colLinks}>
                {col.links.map((l) => (
                  <li key={l.label}>
                    {l.href
                      ? <a href={l.href}>{l.label}</a>
                      : <Link to={l.to}>{l.label}</Link>
                    }
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <hr className={styles.divider} />
        <div className={styles.bottom}>
          <p className={styles.copy}>© {new Date().getFullYear()} InviteEngine. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
